import axios from 'axios';

const IdentityProvider = axios.create({
    baseURL: process.env.BASE_URL
        ? process.env.BASE_URL
        : '/'
});

export default IdentityProvider;
